import { styled } from '@mui/material'

export const Spacer = styled('span', { name: 'Spacer', skipSx: true })({
  width: 12,
  marginRight: 10,
})
